import React,{Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip} from 'recharts';

import './Overview.css';

class Chart extends Component {
  constructor() {
    super();
    this.state = {
      chartData: [{date:moment(),"Deal Claimed":0,"Check ins":0}],
      checkInData: [{x:0,y:0}],
      dealCount:0,
      checkInCount:0,
      chart:[]
    }
  }
  componentWillReceiveProps(nextProps){
    this.setState({
      dealCount:0,
      checkInCount:0
    })
    if(nextProps.chartDetail.Result) {
      if(nextProps.chartDetail.Result.length>0) {
        this.groupChartData(nextProps.chartDetail.Result);
      }
      else{
        this.setState({
         chartData:[{date:moment(),"Deal Claimed":0,"Check ins":0}],
          dealCount:0,
          checkInCount:0
        })
        this.props.dataCount(0, 0);
      }
    }
  }
  groupChartData=(chartData)=>{
    let chartDetailDate =[];
    for (let i = 0; i < chartData.length; i++) {
     // console.log('date',moment(moment.utc(chartData[i]["Activitydate"]).toDate()).format('MM/DD/YYYY'));
      if (!chartDetailDate.includes(moment(moment.utc(chartData[i]["Activitydate"]).toDate()).local().format('MM/DD/YYYY'))) {
        chartDetailDate.push(moment(moment.utc(chartData[i]["Activitydate"]).toDate()).format('MM/DD/YYYY'))
      }
    }
    let dates = [...chartDetailDate];
    let FormatArray=[];
    for(let j=0;j<dates.length;j++) {
      let dealCount=0;
      let checkinCount=0;
      for (let i = 0; i < chartData.length; i++) {
        if (moment(moment.utc(chartData[i]["Activitydate"])).local().format('MM/DD/YYYY')===dates[j]) {
          dealCount = dealCount + chartData[i]["DealClaimedCount"];
          checkinCount = checkinCount + chartData[i]["CheckinCount"];
        }
      }
      FormatArray.push({date:dates[j],checkinCount:checkinCount,dealCount:dealCount})
    }
   // console.log('formatArray',FormatArray);
    this.setState({chart:FormatArray},()=>{
      let chartData = this.state.chart.map((d) => {
        return { date:moment(d.date).format('MMM Do, YYYY'),
          "Deal Claimed":d.dealCount,
          "Check ins":d.checkinCount}
      })
      this.setState({chartData});
      chartData.forEach((data) => {
        this.state.dealCount = this.state.dealCount + data['Deal Claimed'];
      });
      chartData.forEach((data) => {
        this.state.checkInCount = this.state.checkInCount + data['Check ins'];
      });
      this.props.dataCount(this.state.dealCount, this.state.checkInCount);

    });
}

  render(){
    const { chartData }=this.state;
    return(
        <div className={'line-chart'}>
          <LineChart width={800} height={300} data={chartData}
                     margin={{top: 5, right: 50, left: 20, bottom: 5}}>
            <XAxis dataKey="date"/>
            <YAxis/>
            <CartesianGrid strokeDasharray="3 3" vertical={false}/>
            <Tooltip/>
            <Line type="monotone" dataKey="Deal Claimed" stroke="rgb(3,127,3)" activeDot={{r: 8}}/>
            <Line type="monotone" dataKey="Check ins" stroke="rgb(239,135,51)" />
          </LineChart>

        </div>
    );
  }
}
const mapStateToProps=(state)=> {
  return {
    chartDetail:state.chartDetail,
    user:state.loginResponse
  }
};
export default connect(mapStateToProps,null)(Chart);